<template>
  <nav class="navbar">
    <router-link to="/" class="nav-brand">Manolito</router-link>

    <div class="nav-links">
      <router-link to="/">Home</router-link>
      <router-link to="/cuidados">{{ t('nav.cuidados') }}</router-link>
    </div>

    <div class="nav-right">
      <button :class="['lang-btn', { active: locale === 'es' }]" @click="setLocale('es')">ES</button>
      <span class="sep">·</span>
      <button :class="['lang-btn', { active: locale === 'en' }]" @click="setLocale('en')">EN</button>
    </div>
  </nav>
</template>

<script>
import { useI18n } from 'vue-i18n'

export default {
  name: 'NavBar',
  setup() {
    const { t, locale } = useI18n()
    const setLocale = (lang) => { locale.value = lang }
    return { t, locale, setLocale }
  }
}
</script>

<style scoped>
.navbar {
  position: fixed;
  top: 0; left: 0; right: 0;
  z-index: 100;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 40px;
  background: #F5F4EF;
  border-bottom: 1px solid rgba(0,0,0,0.07);
}
.nav-brand {
  font-family: 'Inter', sans-serif;
  font-size: 0.95rem;
  font-weight: 600;
  letter-spacing: 0.04em;
  color: #1a1a1a;
  text-decoration: none;
}
.nav-links {
  display: flex;
  gap: 36px;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
}
.nav-links a {
  font-family: 'Inter', sans-serif;
  font-size: 0.82rem;
  font-weight: 500;
  letter-spacing: 0.06em;
  color: #555;
  text-decoration: none;
  transition: color 0.2s;
}
.nav-links a:hover,
.nav-links a.router-link-active { color: #1a1a1a; }
.nav-right {
  display: flex;
  align-items: center;
  gap: 4px;
}
.lang-btn {
  background: none;
  border: none;
  font-family: 'Inter', sans-serif;
  font-size: 0.75rem;
  font-weight: 500;
  color: #aaa;
  cursor: pointer;
  padding: 2px 4px;
  transition: color 0.2s;
}
.lang-btn.active { color: #1a1a1a; }
.sep { color: #ccc; font-size: 0.75rem; }

@media (max-width: 600px) {
  .navbar { padding: 16px 20px; }
  .nav-links { gap: 20px; }
}
</style>
